import React from "react";

type SVgProps = React.SVGProps<SVGSVGElement>;

export const AttentionIcon = (props: SVgProps) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_1235_15536)">
        <path
          d="M13.351 3.77063L21.5504 18.0084C22.1251 19.0116 21.3826 20.25 20.1995 20.25H3.80072C2.61759 20.25 1.87509 19.0116 2.44978 18.0084L10.6492 3.77063C11.2398 2.74313 12.7604 2.74313 13.351 3.77063Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13.5V9.75"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1235_15536">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
